import "react";
import "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import { instanceOfConstructor } from "../../../shared/lib/constructor/instanceOfConstructor.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
function getFiltersFromGrid(grid) {
  let acc = [];
  grid.items.forEach((item) => {
    if (instanceOfConstructor(item)) {
      const subGridItems = getFiltersFromGrid(item);
      acc = [...acc, ...subGridItems];
      return;
    }
    acc.push(item);
  });
  return acc;
}
export {
  getFiltersFromGrid
};
